import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Row, Col, Drawer } from 'antd';
import Privacy from './Privacy';

const { Footer } = Layout;

const PageFooter = () => {
	const [showPrivacy, setShowPrivacy] = useState(false);
	function onClickPrivacy(e) {
		e.preventDefault();
		setShowPrivacy(true);
	}
	return (
		<Footer>
			<Drawer
				title="Privacy Policy"
				closable
				width={360}
				onClose={() => { setShowPrivacy(false); }}
				visible={showPrivacy}
			>
				<Privacy />
			</Drawer>
			<Row>
				<Col span={24}>
					<span>
						<a href="/about">About</a>
						<a href="#privacy" onClick={onClickPrivacy}>Privacy</a>(c) 2022
					</span>
				</Col>
			</Row>
		</Footer>
	);
};

export default withRouter(PageFooter);



// WEBPACK FOOTER //
// ./src/components/PageFooter.js